<div class="navigation-wrapper" *ngIf="!navigationHidden">
  <div class="left">
    <div class="logo"></div>
  </div>
  <div class="right">
    <div class="nft" *ngIf="nftPage">
      <div class="text typo-body-regular">
        <strong>Package</strong> {{ selectedPackage }}
      </div>
      <ark-button type="secondary" size="small" (click)="gotoPackages()"
        >CHANGE</ark-button
      >
    </div>
    <!-- <ark-button class="invitation-request" size="medium" *ngIf="!loggedIn" (click)="requestInvitation()">Request invitation</ark-button> -->
    <!-- <ark-button size="small" *ngIf="!loggedIn" (click)="logOut()">LOG IN</ark-button> -->

    <div class="menu" *ngIf="!menuHidden">
      <div class="menu-item" (click)="goto('home')">
        <ark-icon icon="navigation-home" color="dark" size="large"></ark-icon>
        <div class="description typo-body-xsmall">Home</div>
      </div>
      <div class="menu-item" (click)="goto('caster-pro')">
        <ark-icon
          icon="navigation-supported"
          color="dark"
          size="large"
        ></ark-icon>
        <div class="description typo-body-xsmall">Caster Pro</div>
      </div>
      <div class="menu-item" (click)="goto('caster-options')">
        <ark-icon
          icon="navigation-supported"
          color="dark"
          size="large"
        ></ark-icon>
        <div class="description typo-body-xsmall">Caster</div>
      </div>
      <div class="menu-item" (click)="goto('certifier-options')">
        <ark-icon
          icon="navigation-supported"
          color="dark"
          size="large"
        ></ark-icon>
        <div class="description typo-body-xsmall">Certifier</div>
      </div>
      <div class="menu-item" (click)="toggleProfile()">
        <ark-icon
          icon="navigation-profile-black"
          color="dark"
          size="large"
        ></ark-icon>
        <div class="description typo-body-xsmall">Profile</div>
      </div>
      <div class="profile-arrow-wrapper" (click)="toggleProfile()">
        <ark-icon
          class="profile-arrow"
          icon="navigation-arrow-down"
          color="dark"
          size="tiny"
        ></ark-icon>
        <div
          class="profile-popup"
          [delayClickOutsideInit]="true"
          (clickOutside)="openProfile = false"
          *ngIf="openProfile"
        >
          <!-- <div class="hr"></div> -->
          <div class="popup-item" (click)="logOut()">
            <ark-icon
              icon="profile-log-out"
              color="dark"
              size="medium"
            ></ark-icon>
            <div class="item-text typo-body-regular">Log out</div>
          </div>
          <div class="links typo-body-small">
            <a
              href="https://www.thesolutionsmovement.org/privacy-policy"
              target="_blank"
              >Privacy Policy</a
            >
            ·
            <a
              href="https://www.thesolutionsmovement.org/terms-and-conditions"
              target="_blank"
              >Terms of Use</a
            >
            <br />©2022 Solutions Movement
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
